import { useTranslation } from 'react-i18next';

import { SyncOptionsContactExport } from '@work4all/models/lib/Enums/SyncOptionsContactExport.enum';

import { CheckboxRadioItem } from '../../../../input/checkbox-radio-item/CheckboxRadioItem';

type Props = {
  mode: SyncOptionsContactExport;
  maximumAllowedMode: SyncOptionsContactExport;
  onChange: (mode: SyncOptionsContactExport) => void;
  withNone?: boolean;
  disabled?: boolean;
};

export const ContactExportModeCheckboxes = ({
  mode,
  maximumAllowedMode,
  onChange,
  withNone = false,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();

  const allContactsDisabled =
    maximumAllowedMode === SyncOptionsContactExport.NO_EXPORT ||
    maximumAllowedMode === SyncOptionsContactExport.PERSONAL_CONTACTS;

  const personalContactsDisabled =
    maximumAllowedMode === SyncOptionsContactExport.NO_EXPORT;

  return (
    <>
      <CheckboxRadioItem
        control="radio"
        label={t('EXCHANGE_SYNCHRONIZATION.CONTACT_TYPES.ALL_CONTACTS')}
        checked={
          !allContactsDisabled && mode === SyncOptionsContactExport.ALL_CONTACTS
        }
        onChange={() => onChange(SyncOptionsContactExport.ALL_CONTACTS)}
        disabled={disabled || allContactsDisabled}
      />

      <CheckboxRadioItem
        control="radio"
        label={t(
          'EXCHANGE_SYNCHRONIZATION.CONTACT_TYPES.ONLY_PERSONAL_CONTACTS'
        )}
        checked={
          !personalContactsDisabled &&
          mode === SyncOptionsContactExport.PERSONAL_CONTACTS
        }
        onChange={() => onChange(SyncOptionsContactExport.PERSONAL_CONTACTS)}
        disabled={disabled || personalContactsDisabled}
      />

      {withNone && (
        <CheckboxRadioItem
          control="radio"
          label={t('EXCHANGE_SYNCHRONIZATION.CONTACT_TYPES.NO_EXPORT')}
          checked={mode === SyncOptionsContactExport.NO_EXPORT}
          onChange={() => onChange(SyncOptionsContactExport.NO_EXPORT)}
          disabled={disabled}
        />
      )}
    </>
  );
};
